var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-container w-100"},[_c('ui-loading',{attrs:{"loading":_vm.isLoading}}),_vm._v(" "),_c('canvas',{ref:"canvas"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fffb808","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-chart/src/ui-chart.vue
// module id = 731
// module chunks = 0